// Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React from "react";
import ReactDOM from "react-dom";
import "./styles/App.css";
import "./styles/CustomBranding.css";
import { App } from "./components/App";
import { App as StepFlowApp } from "./stepFlowComponents/App/App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { initalizeLogger } from "./logging";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { isFeatureEnabled } from "./configurations";

// Enable hot reload of the module
// eslint-disable-next-line
if ((module as any).hot) {
    // eslint-disable-next-line
  (module as any).hot.accept();
}

initalizeLogger();
if (isFeatureEnabled("stepNavigationFlow")) {
    ReactDOM.render(<StepFlowApp />, document.getElementById("root"));
} else {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                networkMode: "always",
                refetchOnWindowFocus: false,
            },
            mutations: {
                networkMode: "always",
            },
        },
    });

    ReactDOM.render(
        <div>
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </React.StrictMode>
        </div>,
        document.getElementById("root")
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
